<template>
  <div class="page-main">
    <slot v-if="show" />
    <transition name="fade-transform" mode="out-in">
      <router-view ref="route" :key="key" />
      <!-- <keep-alive v-if="cached" ref="ka">
          <router-view ref="route" :key="key" />
        </keep-alive> -->
    </transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: true,
      cached: false,
      fullPath: ''
    }
  },

  computed: {
    key() {
      return this.$route.path
    }
  },
  // TOTO: 页面缓存机制，暂时不做，但是要做
  watch: {
    $route(to) {
      this.cached = !!to.meta.noCache
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.route || this.$refs.ka) {
        this.show = false
      } else {
        this.show = true
      }
    })
  }
}
</script>
<style lang="scss" >
.page-main{
  // width: 80%;
  margin: 0 auto;
  width: 1200px;
}
</style>
